exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".tobaccoUseContainer .tobaccoForm{background-color:rgba(0,0,0,0);box-shadow:none;border:none;padding:1rem 1.5rem}.tobaccoUseContainer .tobaccoForm .formFieldsContainer .title{font-size:25px;font-weight:400;line-height:42px;text-align:center}.tobaccoUseContainer .tobaccoForm .formFieldsContainer .subTitle{font-size:15px;font-weight:400}.tobaccoUseContainer .tobaccoForm .formFieldsContainer .MuiFormControlLabel-root{margin-right:0}.tobaccoUseContainer .tobaccoForm .formFieldsContainer .MuiFormLabel-root,.tobaccoUseContainer .tobaccoForm .formFieldsContainer .MuiFormLabel-root.Mui-error{font-weight:400;font-size:17px}.tobaccoUseContainer .tobaccoForm .formFieldsContainer .MuiFormHelperText-root.Mui-error{font-size:13px;color:#f32e20}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Quoters/Common/TobaccoUse.scss
// module id = 7603
// module chunks = 13